import {
  TextIcon,
  ImageIcon,
  VideoIcon,
  LinkIcon,
  FileIcon,
  RolesIcon,
  TagsIcon,
} from "allIcons";

export const contentRequestItemType = {
  Text: <TextIcon />,
  Image: <ImageIcon />,
  Video: <VideoIcon />,
  Link: <LinkIcon />,
  File: <FileIcon />,
};

export const Modules = {
  ROLES: "roles",
  USERS: "users",
  CATEGORY: "category",
};

export const ModuleIcons = {
  [Modules.ROLES]: <RolesIcon />,
  [Modules.CATEGORY]: <TagsIcon />,
};

export const ThemeColors = {
  Blue: "#0066FF",
}